import { render, staticRenderFns } from "./ModalCadastro.vue?vue&type=template&id=0bf04d4c&"
import script from "./ModalCadastro.vue?vue&type=script&lang=js&"
export * from "./ModalCadastro.vue?vue&type=script&lang=js&"
import style0 from "./ModalCadastro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports